<template>
  <div>
    <div>
      <div
        class="p-2 m-3 rounded alert alert-danger text-center border border-dark"
        v-if="specialOrderDiscountCountDown != ''"
      >
        <i class="icon-gift"></i>
        <small
          class="text-center ml-2"
          v-html="
            $t('lang.orders.specialorderdiscount', {
              discount_end_date: getSpecialOrderDiscountEndDate(),
              discount_countdown: specialOrderDiscountCountDown,
            })
          "
        >
        </small>
      </div>
    </div>
  </div>
</template>
<script>
import { formattersMixin } from "@/_mixins/";
import moment from "moment";
export default {
  data() {
    return {
      specialOrderDiscountCountDown: "",
    };
  },
  created() {
    this.specialCountDown = setInterval(
      () => this.getSpecialOrderDiscountCountdown(),
      1000
    );
  },
  mixins: [formattersMixin],
  props: {
    clientCreationDate: String,
  },
  computed: {},
  ready: function () {},
  methods: {
    getSpecialOrderDiscountEndDate() {
      return moment(this.clientCreationDate).add(168, 'hour').format("YYYY-MM-DD HH:mm:ss");
    },
    getSpecialOrderDiscountCountdown() {
      let isPromotionActive = this.isPromotionActive(this.clientCreationDate, 168);  // promotion7days
      if (isPromotionActive.isActive) {
        let distance = isPromotionActive.distance
        // Time calculations for days, hours, minutes and seconds
        let days = Math.floor(distance / (1000 * 60 * 60 * 24));
        let hours = Math.floor(
          (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
        );
        let minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        let seconds = Math.floor((distance % (1000 * 60)) / 1000);
        // Display the result in the element with id="demo"

        this.specialOrderDiscountCountDown =
          days + "d " + hours + "h " + minutes + "m " + seconds + "s ";
      } else {
        this.specialOrderDiscountCountDown = "";
      }

      this.$emit(
        "setSpecialOrderDiscountCountDown",
        this.specialOrderDiscountCountDown
      );
    },
  },
};
</script>